function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { InfoIcon, InfoInactiveIcon } from '../../Utility/Utility';

const InfoContainer = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Box, _extends({
  height: "24px",
  width: "24px",
  padding: "5px",
  borderRadius: "50%",
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}, props), children);

export const InfoInactive = props => /*#__PURE__*/React.createElement(InfoContainer, _extends({
  bgcolor: "#fff"
}, props), /*#__PURE__*/React.createElement(InfoInactiveIcon, {
  style: {
    width: '100%'
  },
  color: "primary"
}));
export const InfoActive = props => /*#__PURE__*/React.createElement(InfoContainer, _extends({
  bgcolor: "primary.main"
}, props), /*#__PURE__*/React.createElement(InfoIcon, {
  style: {
    width: '100%'
  },
  htmlColor: "#fff"
}));
InfoContainer.propTypes = {
  children: PropTypes.node.isRequired
};